import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'

export const initSentry = (Vue, router) => {
    Sentry.init({
        app: Vue, // Changed from Vue to app for v7+
        dsn: process.env.VUE_APP_SENTRY_DSN,
        sendDefaultPii: true,
        environment: process.env.VUE_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
        integrations: [
            new BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                tracePropagationTargets: [
                    'localhost',
                    /^\//,
                    // MyDocPort API endpoints
                    /^https:\/\/qaapi\.mydocport\.com/,
                    /^https:\/\/api\.mydocport\.com/, // for production
                    'qaapi.mydocport.com',
                    'api.mydocport.com',
                ],
            }),
        ],
        // Performance monitoring
        tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,

        // Release tracking
        release: process.env.VUE_APP_VERSION,

        // Error filtering and preprocessing
        beforeSend(event, hint) {
            // Filter out non-error events in development
            if (process.env.NODE_ENV === 'development') {
                console.log('Sentry event:', event)
            }

            // Filter out network errors that are not actionable
            if (event.exception) {
                const error = hint.originalException

                // Skip network connectivity errors
                if (
                    error &&
                    error.message &&
                    error.message.includes('NetworkError')
                ) {
                    return null
                }

                // Skip cancelled requests
                if (
                    error &&
                    error.message &&
                    error.message.includes('AbortError')
                ) {
                    return null
                }
            }

            return event
        },

        // User context
        initialScope: {
            tags: {
                component: 'vue-app',
            },
        },
    })
}

// Helper function to set user context
export const setSentryUser = user => {
    if (user) {
        Sentry.setUser({
            id: user.sub || user.id,
            email: user.email,
            username: user.name || user.nickname,
        })
    } else {
        Sentry.setUser(null)
    }
}

// Helper function to add context
export const addSentryContext = (key, context) => {
    Sentry.setContext(key, context)
}

// Helper function to capture exception with extra context
export const captureException = (error, context = {}) => {
    Sentry.withScope(scope => {
        Object.keys(context).forEach(key => {
            scope.setContext(key, context[key])
        })
        Sentry.captureException(error)
    })
}

// Helper function for breadcrumbs
export const addBreadcrumb = (
    message,
    category = 'navigation',
    level = 'info'
) => {
    Sentry.addBreadcrumb({
        message,
        category,
        level,
        timestamp: Date.now() / 1000,
    })
}
